import {Injector} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DeviceDetectorService} from 'ngx-device-detector';

let patched = false;

/**
 * Patches {@link MatDialog.open} once, project-wide, so that on mobile devices
 * every dialog is forced to `width: 100vw` and `maxWidth: 100vw`.
 *
 * A DI-provider override cannot be used reliably here because `MatDialogModule`
 * re-provides `MatDialog` in every feature module that imports it, which shadows
 * any root-level override. Patching the prototype affects every `MatDialog`
 * instance regardless of which injector created it.
 */
export function applyMobileDialogPatch(injector: Injector): void {
  if (patched) {
    return;
  }
  patched = true;

  const deviceDetectorService = injector.get(DeviceDetectorService);
  const originalOpen = MatDialog.prototype.open;

  MatDialog.prototype.open = function (this: MatDialog, componentOrTemplateRef: any, config?: MatDialogConfig) {
    const mergedConfig: MatDialogConfig = {...config};
    if (deviceDetectorService.isMobile()) {
      mergedConfig.width = (mergedConfig.maxWidth ?? mergedConfig.width)+  '';
    }

    return originalOpen.call(this, componentOrTemplateRef, mergedConfig);
  };
}
